"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Message_1 = __importDefault(require("../i18n/Message"));
var StockLabel = /** @class */ (function (_super) {
    __extends(StockLabel, _super);
    function StockLabel(props) {
        return _super.call(this, props) || this;
    }
    StockLabel.prototype.render = function () {
        var numberOfStocks = Number(this.props.numberOfStocks);
        var numberOfStocksFormatted = numberOfStocks.toLocaleString();
        var salesMethodMaker = Boolean(this.props.salesMethodMaker);
        var salesMethodLabel = this.props.salesMethodLabel;
        if (!this.props) {
            return null;
        }
        if (salesMethodMaker) {
            return (react_1.default.createElement("p", { className: "item-stock green", dangerouslySetInnerHTML: { __html: salesMethodLabel } }));
        }
        else {
            if (numberOfStocks > 9) {
                return (react_1.default.createElement("p", { className: "item-stock green" },
                    react_1.default.createElement(Message_1.default, { messageId: "stock.inStock", values: { numberOfStocks: numberOfStocksFormatted }, escapeHtml: true })));
            }
            else if (numberOfStocks > 0 && numberOfStocks <= 9) {
                return (react_1.default.createElement("p", { className: "item-stock red" },
                    react_1.default.createElement(Message_1.default, { messageId: "stock.limitedStock", values: { numberOfStocks: numberOfStocksFormatted } })));
            }
            else if (numberOfStocks <= 0) {
                return (react_1.default.createElement("p", { className: "item-stock noStock" },
                    react_1.default.createElement(Message_1.default, { messageId: "stock.noStock" })));
            }
            else {
                return null;
            }
        }
    };
    StockLabel.numberOfStocks = {
        numberOfStocks: prop_types_1.default.number.isRequired,
        salesMethodMaker: prop_types_1.default.bool.isRequired,
        salesMethodLabel: prop_types_1.default.string.isRequired,
    };
    return StockLabel;
}(react_1.default.Component));
exports.default = StockLabel;
//# sourceMappingURL=StockLabel.js.map